// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__2bgzS","inner":"styles_inner__mEOZW","headImg":"styles_headImg___I0l2","lvlImg":"styles_lvlImg__b5DaO","iconImg":"styles_iconImg__MduHE"};